<style>
.Account_Type {
    max-width: 1540px;
    width: 100%;
}

.users_top li {
    padding: 20px;
}

.Account_Type .users_top {
    display: flex;
}

.Account_Type .users_top li {
    max-width: 256px;
    width: 100%;
    padding: 20px 20px 15px;
    background: #FFF;
    box-sizing: border-box;
}

.Account_Type .users_top .total_ftd {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.Account_Type .users_top .total_ftd .total_ftd_right {
    display: flex;
    align-items: center;
}

.Account_Type .users_top .total_ftd .total_ftd_left span {
    font-size: 16px;
}

.Account_Type .users_top .total_ftd .total_ftd_right span {
    font-size: 14px;
    color: #1DD1A1;
}

.Account_Type .users_top .total_ftd .total_ftd_right img {
    width: 24px;
    height: 24px;
}

.Account_Type .users_top li h3 {
    font-size: 30px;
    color: #000;
    line-height: 1.367;
    padding-bottom: 20px;
}

.Account_Type .users_top li p {
    font-size: 14px;
    color: #898787;
}

.Account_Type .users_top li h4 {
    font-size: 16px;
    color: #000;
}
.users_bottom {
    display: flex;
}
</style>
<template>
    <div class="Account_Type">
        <ul class="users_top">
            <li class="Gross_Deposit">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Gross Deposit</span></div>
                    <div class="total_ftd_right"><span>6.0%</span><img src="../assets/img/total_ftd_rise.webp" alt=""></div>
                </div>
                <h3>100,000</h3>
                <p>Previous Month</p>
                <h4>100,000</h4>
            </li>
            <li class="Net_Deposit">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Net Deposit</span></div>
                    <div class="total_ftd_right"><span>6.0%</span><img src="../assets/img/total_ftd_rise.webp" alt=""></div>
                </div>
                <h3>100,000</h3>
                <p>Previous Month</p>
                <h4>100,000</h4>
            </li>
            <li class="Ftd_Deposit">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>FTD Deposit</span></div>
                    <div class="total_ftd_right"><span>6.0%</span><img src="../assets/img/total_ftd_rise.webp" alt=""></div>
                </div>
                <h3>100,000</h3>
                <p>Previous Month</p>
                <h4>100,000</h4>
            </li>
            <li class="Net_Gross">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Net/Gross</span></div>
                    <div class="total_ftd_right"><span>6.0%</span><img src="../assets/img/total_ftd_rise.webp" alt=""></div>
                </div>
                <h3>100,000</h3>
                <p>Previous Month</p>
                <h4>100,000</h4>
            </li>
            <li class="Withdrawal">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Withdrawal</span></div>
                    <div class="total_ftd_right"><span>6.0%</span><img src="../assets/img/total_ftd_rise.webp" alt=""></div>
                </div>
                <h3>100,000</h3>
                <p>Previous Month</p>
                <h4>100,000</h4>
            </li>
        </ul>
        <div class="users_bottom">
            <div id="typecontainer" style="height: 600px;width: 1540px;overflow: hidden;"></div>
    
        </div>
    </div>
</template>
<script>
var echarts = require('echarts')
export default {
    data () {
        return {}
    },

    methods () {

    },
    mounted () {
        var dom = document.getElementById('typecontainer')
        var myChart = echarts.init(dom, null, {
            renderer: 'canvas',
            useDirtyRect: false,
        })
        option = {
            title: {
                text: ''
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
           
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: 'Email',
                    type: 'line',
                    data: [120, 132, 101, 134, 90, 230, 210]
                },
                {
                    name: 'Union Ads',
                    type: 'line',
                    data: [220, 182, 191, 234, 290, 330, 310]
                },
                {
                    name: 'Video Ads',
                    type: 'line',
                    data: [150, 232, 201, 154, 190, 330, 410]
                },
                {
                    name: 'Direct',
                    type: 'line',
                    data: [320, 332, 301, 334, 390, 330, 320]
                },
                {
                    name: 'Search Engine',
                    type: 'line',
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }
            ]
        }
        // var app = {}
        var option
        if (option && typeof option === 'object') {
            myChart.setOption(option)
        }
        window.addEventListener('resize', myChart.resize)
        // console.log(app)
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Deposit.vue